<div
  *ngIf="canAdd; else noAdd"
  class="mt-4 w-full mx-auto lg:w-1/2 bg-green-50 border border-green-500 rounded pt-8 px-8 pb-2 flex flex-row justify-items-stretch"
>
  <mat-form-field
    appearance="fill"
    class="flex flex-col flex-grow w-full"
    [testId]="testIds.SEARCH_CUSTOMER_EQUIPMENT_INPUT"
  >
    <mat-label>Search customers equipment to book in for repair</mat-label>
    <input
      class="w-full"
      matInput
      data-cy="add-item-input"
      placeholder="Name or serial number"
      [formControl]="search"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="handleOptionSelected($event)"
    >
      <ng-container *ngIf="customerEquipment$ | async as equipment">
        <mat-option
          *ngFor="let option of equipment"
          [testId]="testIds.CUSTOMER_EQUIPMENT_OPTION"
          [value]="option"
        >
          <p>{{ option.name }}</p>
          <p *ngIf="option.serial_number" class="text-gray-500 text-sm">
            Serial number: {{ option.serial_number }}
          </p>
        </mat-option>
        <ng-container *ngIf="noEquipment; else addEquipmentOption">
          <mat-option
            [value]="addNewItemOption"
            [testId]="testIds.NO_EQUIPMENT_ADD_OPTION"
          >
            <p><em>Add new equipment</em></p>
            <p class="text-gray-500 text-sm">
              Customer has no equipment added.
            </p>
          </mat-option>
        </ng-container>
        <ng-template #addEquipmentOption>
          <mat-option
            [value]="addNewItemOption"
            [testId]="testIds.ADD_EQUIPMENT_OPTION"
            ><em>Add new equipment</em>
          </mat-option>
        </ng-template>
      </ng-container>
    </mat-autocomplete>
  </mat-form-field>
</div>

<ng-template #noAdd>
  <div
    class="my-4"
    data-cy="cannot-add-items"
    [testId]="testIds.CANNOT_ADD_JOB"
  >
    <em>You cannot add items to this repair invoice.</em>
  </div>
</ng-template>
